import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { Button } from "react-bootstrap";
import StatutsService from "../../services/StatutsService";
import MotsClesService from "../../services/MotsClesService";
import { useSelector } from "react-redux";

export default function IndexMotsCles() {

    //##########################/// METHODES ##########################///
    const [motscles, setMotscles] = useState([])
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)


    //get liste
    const fetchMotsCles = async () => {
        await MotsClesService.index(token).then((res) => {
            setMotscles(res.data.motscles)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }


    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.motscles_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                MotsClesService.delete(param,token).then((response) => {
                    if (response.data.erreur) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.erreur
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchMotsCles()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.erreur
                    })
                })
            }
        })
    }

    //Rendre actif ou inactif un role
    const updateStatut = async (id, statut, table) => {
        //let form = { id, statut, table }
        await StatutsService.changeStatut(id, statut, table,token).then(response => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchMotsCles()
            }
        }).catch(error => {
            console.log(error)
        })
    }


    useEffect(() => {
        fetchMotsCles()
        $("#submenu-2").addClass("show")
    }, []) //Le crochet vide indique à React d'exécuter l'effet uen seule fois

    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Mots-cles </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des mots-cles <Link className="btn btn-primary btn-sm" to={myroutes.motscles_create} title="Ajouter"><i className="fa fa-plus-circle"></i></Link> </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 text-left data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className=" text-white">N°</th>
                                            <th className=" text-white">Libelle</th>
                                            <th className=" text-white">Description</th>
                                            <th className=" text-white">Date modification</th>
                                            <th className=" text-white">Statuts</th>
                                            <th className=" text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider" style={{textAlign : "left"}}>
                                        {motscles.length > 0 && motscles.map((item, index) => (
                                            <tr key={index}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{item.libelle}
                                                </td>
                                                <td className=""><span className="truncate">{item.description}</span></td>
                                                <td className=""><span>{dayjs(item.updated_at).format("DD/MM/YYYY H:m:s")} par </span>
                                                    <span className="notex">{item.updated_by ? item.updated_by_nom : ''} {item.updated_by ? item.updated_by_prenoms : ''}</span>
                                                </td>
                                                <td className=""><span className={(item.get_statut === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.get_statut}</span></td>
                                                <td className="justify-content-center">
                                                    <Button className={item.get_statut === "ACTIF" ? "btn btn-sm btn-success" : "btn btn-sm btn-dark"} onClick={() => updateStatut(item.id, item.get_statut === "ACTIF" ? "desactivation" : "activation", "motscles")} title="Changer le statut">
                                                        <i className={item.get_statut === "ACTIF" ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-primary" onClick={() => goToEdit(item.id)} title="Modifier">
                                                        <i className="fas fa-edit"></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                        <i className="fas fa-trash"></i></Button>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}



                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}